export enum configLinkTypes {
  HelpPage,
  PiAHelpDesk,
  PatchNotes,
  Manual,
  Push,
  Tourencode,
  PumpenHeim,
}
